import styled from 'styled-components';
import { buttonBase } from '../styled.js';
import { stretchButton } from '../utils/stretchButton.js';
import { getButtonSize } from '../utils/getButtonSize.js';
import { getButtonAppearance } from '../utils/getButtonAppearance.js';

var Button = styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-422i8p-0"
})(["", ";", ";", ";", ";"], buttonBase, stretchButton, function (props) {
  return getButtonSize(props.size);
}, function (props) {
  return getButtonAppearance(props.appearance);
});

export { Button };
